import React, { Component, PureComponent } from 'react';
import { DropdownList } from 'react-widgets';

interface Props {
  placeholder?: string;
  onChange: (val: Language[]) => void;
  value?: Language[];
  className?: string;
  disabled?: boolean;
}

interface OptionProps {
  label: string;
  value: string;
}

interface SingleProps {
  onChange: (val: Language) => void;
  value: Language;
  onRemove: () => void;
  languageOption: OptionProps[];
  totalLanguages: number;
  disabled?: boolean;
}

interface State {
  languages: Language[];
}

interface Language {
  language: string;
  isPrimary: boolean;
}

const options = [
  { label: 'English', value: 'English' },
  { label: 'Arabic', value: 'Arabic' },
  { label: 'Urdu', value: 'Urdu' },
  { label: 'Farsi', value: 'Farsi' },
];

class SingleInput extends PureComponent<SingleProps> {
  setAsPrimary = () => {
    if (this.props.disabled) {
      return;
    }
    const { value, totalLanguages } = this.props;

    if (totalLanguages > 1 && !value.isPrimary) {
      value.isPrimary = !value.isPrimary;
      this.props.onChange(value);
    }
  };

  setLanguage = (e: { value: string }) => {
    const { value } = this.props;
    value.language = e.value;
    this.props.onChange(value);
  };

  render() {
    return (
      <div className="row gutter-5 mb-2">
        <div className="col input-group ">
          <DropdownList
            value={this.props.value.language}
            data={this.props.languageOption}
            textField={'label'}
            valueField={'value'}
            defaultValue={this.props.value.language}
            placeholder={'Select Language'}
            onChange={this.setLanguage}
            disabled={this.props.disabled}
          />
        </div>

        <div className="col-auto">
          <div
            onClick={this.setAsPrimary}
            className={`form-control font-sm h-100 px-2 d-flex align-items-center justify-content-center cursor-pointer ${
              this.props.value.isPrimary ? 'text-shamrock' : 'text-gray-400'
            }`}
          >
            <i className="icon-tick"></i>
          </div>
        </div>
        {!this.props.disabled && this.props.value.language && (
          <div className="col-auto d-flex">
            <i
              onClick={this.props.onRemove}
              className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"
            ></i>
          </div>
        )}
      </div>
    );
  }
}

// tslint:disable-next-line: max-classes-per-file
class LanguageInput extends Component<Props, State> {
  static defaultProps = {
    // tslint:disable-next-line: no-console
    value: '',
  };

  state = {
    languages:
      this.props.value && this.props.value.length > 0
        ? this.props.value
        : [
            {
              language: '',
              isPrimary: false,
            },
          ],
  };

  componentDidMount() {
    const languages =
      this.props.value && this.props.value.length > 0
        ? this.props.value
        : [
            {
              language: '',
              isPrimary: false,
            },
          ];
    this.state = {
      languages,
    };
    this.props.onChange(languages);
  }

  addMoreComponent = () => {
    const { onChange } = this.props;
    const { languages } = this.state;
    if (!languages.find((x) => !x.language)) {
      languages.push({
        language: '',
        isPrimary: false,
      });
      this.setState({ languages });

      onChange(languages);
    }
  };

  handleOnChange = (language: Language, index: number) => {
    const { onChange } = this.props;
    let { languages } = this.state;
    if (language.isPrimary) {
      languages = languages.length
        ? languages.map((d: Language) => {
            return {
              ...d,
              isPrimary: false,
            };
          })
        : [];
    }
    languages[index] = language;
    if (!languages.find((x) => x.isPrimary)) {
      languages[0].isPrimary = true;
    }

    this.setState({ languages });
    onChange(languages);
  };

  handleOnRemove = (index: number) => {
    const { onChange } = this.props;
    const { languages } = this.state;
    languages.splice(index, 1);
    if (!!languages?.length && !languages.find((x) => x.isPrimary)) {
      languages[languages.length - 1].isPrimary = true;
    }
    this.setState({ languages });
    onChange(languages);
  };

  renderInputs = () => {
    const { languages } = this.state;

    const inputs = [];
    const selectedOptions = languages?.map((x) => x.language);
    for (let i = 0; i < languages.length; i++) {
      inputs.push(
        <SingleInput
          onChange={(value: Language) => this.handleOnChange(value, i)}
          value={languages[i]}
          onRemove={() => this.handleOnRemove(i)}
          languageOption={options.filter(
            (x) => !selectedOptions.includes(x.value)
          )}
          totalLanguages={languages.length}
          disabled={this.props.disabled}
        />
      );
    }

    return inputs;
  };

  render() {
    return (
      <>
        {this.renderInputs()}
        <div className="w-100"></div>
        {!this.props.disabled && (
          <button
            type="button"
            className="btn btn-link font-sm p-0 font-weight-semibold"
            onClick={this.addMoreComponent}
          >
            + add one more
          </button>
        )}
      </>
    );
  }
}

export default LanguageInput;
